import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { compose, setPropTypes, defaultProps,withState,lifecycle } from 'recompose'
import {
  Collapse} from '@material-ui/core';
import {
  Icon } from  'semantic-ui-react'

import { Main } from './styled'

const StdForm = (props) => {
  const { 
    title, 
    children, 
    accessoriesHeader, 
    fitContent, 
    enableCollapse,
    showCollapse,
    setShowCollapse,
    highlight,
    showHeader=true,
    style } = props

  return (
    <Main fitContent={fitContent} className={highlight ? 'highlight' : ''} style={style}>
      {showHeader&&<div className='header'>
        {title}
        <div className='accessories'>
          {accessoriesHeader?<div>{accessoriesHeader}</div>:null}
          {enableCollapse?
            <div><Icon size='tiny' name={`${showCollapse?'angle double up':'angle double down'}`} link circular inverted color='teal' onClick={()=>setShowCollapse(!showCollapse)}/></div>
            :null
          }
        </div>
      </div>}
      <Collapse in={showCollapse}>
        <div className={`content ${showHeader?'':'hideHeader'}`}>
          {children}
        </div>
      </Collapse>
    </Main>
  )
}

const propTypes = {
  // title: PropTypes.string
}

const defaultProp = {
  title: 'Title',
  fitContent: true,
  enableCollapse: false
}

export default compose(
  setPropTypes(propTypes),
  withState('showCollapse','setShowCollapse',true),
  defaultProps(defaultProp),
  connect((state, props) => ({
    children: props.children
  })),
)(StdForm)